<template>
  <template v-if="zone">
    <div v-if="zone?.textHeader?.text" class="textHeader">
      <span>
        {{ zone.numberOfPromotions != '' ? zone.textHeader.text : '' }}
      </span>
    </div>

    <div v-if="zone.htmlSnippet">
      <HtmlSnippet :html-snippet="zone.htmlSnippet" />
    </div>

    <template v-if="zone.promotion">
      <div class="promotion-box">
        <Promotion :promotion="zone.promotion" />
      </div>
    </template>

    <div v-if="zone.imageMap">
      <ImageMap :image-map="zone.imageMap" />
    </div>
  </template>
</template>

<script setup>
import ImageMap from '~/components/mediaTypes/imageMap.vue';
import HtmlSnippet from '~/components/mediaTypes/htmlSnippet.vue';
import Promotion from '~/components/mediaTypes/promotion.vue';

defineProps({
  zone: {
    type: Object,
    default: null,
  },
});
</script>

<style lang="scss" scoped>
@import '~settingSCSS';
@import '~@core/csg/src/scss/encodedIcons/mcom/_wallet-filled.scss';
.promoHeaderTitlesWallet {
  padding-top: rem-calc(7);
  font-weight: 700;
  font-style: normal;
  font-size: 1.2rem;
  margin-bottom: 0.5rem;
}
.promoHeaderTitles {
  font-weight: 700;
  font-style: normal;
  font-size: rem-calc(20);
  margin-bottom: rem-calc(8);
}
.section-two {
  padding-left: rem-calc(20);
}
.section-one {
  padding: rem-calc(20);
}
.promo-wallet-icon {
  width: rem-calc(50);
  float: left;
}
.promotion-box {
  height: 100%;
  width: 100%;
}
</style>

<style lang="scss" brand="mcom" scoped>
.textHeader {
  padding: rem-calc(10);
  padding-left: rem-calc(0);
  font-size: rem-calc(18);
  text-transform: uppercase;
}
</style>

<style lang="scss" brand="bcom" scoped>
.textHeader {
  padding: rem-calc(10);
  padding-left: rem-calc(0);
  font-size: rem-calc(14);
  font-weight: 700;
  text-transform: uppercase;
}
</style>
